import { render } from "./EventPayoutSetting.vue?vue&type=template&id=3ec8ef6c&scoped=true"
import script from "./EventPayoutSetting.vue?vue&type=script&lang=js"
export * from "./EventPayoutSetting.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=3ec8ef6c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec8ef6c"]])

export default __exports__